'use client';

import Link from '@eliadmin/core/src/components/link';

import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import Image from '@eliadmin/core/src/components/image/image-wrapped';

export function SubpageHeader({
  breadcrumbs,
  title,
  ourProducts = false,
}: {
  breadcrumbs: { name: string }[];
  title: string;
  ourProducts?: boolean;
}) {
  return (
    <section
      className={cn(
        'custom-section',
        'relative pb-8 pt-24 sm:pb-10 sm:pt-32 md:pt-[211px] lg:pb-16',
      )}
    >
      <div
        className={cn(
          'custom-container',
          'relative z-10 flex flex-col items-start justify-start gap-4 sm:gap-5',
        )}
      >
        <div className="flex flex-wrap items-center justify-start gap-2">
          <Link
            prefetch={false}
            href={ROUTES.HOME()}
            className="text-sm font-medium text-white transition-all hover:opacity-90 sm:text-base lg:text-lg"
          >
            Domov
          </Link>
          {ourProducts && (
            <>
              <span className="text-sm font-medium text-[#747474] sm:text-base lg:text-lg">/</span>
              <Link
                prefetch={false}
                href={'/nase-produkty'}
                className="text-sm font-medium text-white transition-all hover:text-white/75 sm:text-base lg:text-lg"
              >
                Naše produkty
              </Link>
            </>
          )}
          {breadcrumbs &&
            breadcrumbs.map(breadcrumb => (
              <>
                <span className="text-sm font-medium text-[#747474] sm:text-base lg:text-lg">
                  /
                </span>
                <p className="text-sm font-medium text-white/50 sm:text-base lg:text-lg">
                  {breadcrumb.name}
                </p>
              </>
            ))}
        </div>
        <h1 data-ea-visual-tag="h2" className="font-oswald text-3xl font-medium uppercase text-white sm:text-4xl lg:text-5xl">
          {title}
        </h1>
      </div>
      <div className={cn('absolute inset-0 z-[1] h-full w-full', 'ea-subpage-header__overlay')} />
      <Image
        src={'/images/sub.jpg'}
        alt={title}
        width={0}
        height={0}
        className="absolute inset-0 z-0 h-full w-full object-cover object-center"
        sizes="100vw"
      />
    </section>
  );
}
